export type TJobType =
  | 'VLTCalculation'
  | 'PlanningCalculation'
  | 'LambdaRunner'
  | 'PlanningSettingCalculation'
  | 'SourceMatching';

export const JobTypes: Record<TJobType, string> = {
  VLTCalculation: 'jobType.VLTCalculation',
  PlanningCalculation: 'jobType.PlanningCalculation',
  LambdaRunner: 'jobType.LambdaRunner',
  PlanningSettingCalculation: 'jobType.PlanningSettingCalculation'
};

const CancellableJobTypes = [
  'PlanningCalculation',
  'VLTCalculation',
  'PlanningSettingCalculation',
  'SourceMatching'
] as const;
export type CancellableJobType = (typeof CancellableJobTypes)[number];

// This function checks if a job type is cancellable by using CallableJobTypes
export const isCancellable = (jobType: TJobType): boolean => {
  return CancellableJobTypes.includes(jobType as CancellableJobType);
};

export const JobTypesArray: TJobType[] = Object.keys(JobTypes) as TJobType[];

export default JobTypes;
